export function getPlaceType(isPromoSnippet?: boolean) {
  return isPromoSnippet ? 'Open_listingjk_promo_block' : 'Open_listing_jk';
}
